@if(is_loading) {
<div class="spinner-body">
  <div class="spinner-wrapper">
    <div class="spinner-wrapper-loader">
      <p>Loading...</p>
      <div class="spinner-wrapper-circle">
        <div class="spinner-wrapper-circle-content">
        </div>
      </div>
    </div>
  </div>
</div>
}


<div class="wizard">
  <div class="wizard-form">
    @if(env.debug) {
    <button (click)="fillDummyData()" style="opacity: 0; position: absolute; pointer-events: all;">Fill Data</button>
    }
    <form id="studentForm" [formGroup]="wizardForm" (ngSubmit)="onSubmit()">
      <h2 class="wizard__heading">Tell us about the person studying</h2>
      <div class="form-group">
        <label for="studentName">Student name</label>
        <input id="studentName" type="text" formControlName="student_name" />
        @if(validateFormControl('student_name')){
        <p class="error">{{validationMessage('student_name')}}</p>
        }
      </div>

      <div class="form-group">
        <label for="studentSurname">Student surname</label>
        <input id="studentSurname" type="text" formControlName="student_surname" />
        @if(validateFormControl('student_surname')){
        <p class="error">{{validationMessage('student_surname')}}</p>
        }
      </div>

      <div class="form-group">
        <label for="studentIdNumber">Student ID number</label>
        <input id="studentIdNumber" type="tel" maxlength="13" formControlName="student_id_number"
          (keypress)="validateNumericInput($event)" />
        @if(validateFormControl('student_id_number')){
        <p class="error">{{validationMessage('student_id_number')}}</p>
        }
      </div>

      <div class="form-group">
        <label for="studentEmail">Student email</label>
        <input id="studentEmail" type="email" formControlName="student_email" />
        @if(validateFormControl('student_email')){
        <p class="error">{{validationMessage('student_email')}}</p>
        }
      </div>

      <div class="form-group">
        <label for="studentContactNumber">Student contact number</label>
        <input id="studentContactNumber" type="tel" maxlength="10" (keypress)="validateNumericInput($event)"
          formControlName="student_contact_number" />
        @if(validateFormControl('student_contact_number')){
        <p class="error">{{validationMessage('student_contact_number')}}</p>
        }
      </div>
      @if(is_ei_unique_link == false && !isRecommendedInstitution && !isEIGroup){
      <div #educationalInstitution class="form-group">

        <label for="educationalInstitution">Select educational institution</label>
        <input id="educationalInstitution" (focus)="scrollToInstitution()" matInput class="input-text-autocomplete"
          type="text" placeholder="Enter 3 or more characters" formControlName="educational_institution" maxlength="100"
          [matAutocomplete]="auto" [matAutocompletePosition]="'below'">
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="getEiName">
          <mat-option *ngFor="let ei of filteredEIS | async" [disabled]="ei.id === 0" [value]="ei">
            {{ ei.name}}
          </mat-option>
          <button class="primary-button" (click)="recommendedInstitution()">Not finding your educational
            institution?</button>
        </mat-autocomplete>

        @if(validateFormControl('educational_institution')){
        <p class="error">{{validationMessage('educational_institution')}}</p>
        }
      </div>
      }

      @if(isEIGroup){
      <div #educationalInstitution class="form-group">
        <label class="input-label">Select educational institution</label>
        <input (focus)="scrollToInstitution()" matInput class="input-text-autocomplete" type="text"
          placeholder="Select educational institution" formControlName="educational_institution"
          [matAutocomplete]="auto" [matAutocompletePosition]="'below'">
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="getEiName">
          @for (ei of educationalInstitutions; track $index) {
          <mat-option [disabled]="ei.id === 0" [value]="ei">
            {{ ei.name}}
          </mat-option>
          }
          <button class="primary-button" (click)="recommendedInstitution()">Not finding your educational
            institution?</button>
        </mat-autocomplete>

        @if(validateFormControl('educational_institution')){
        <p class="error">{{validationMessage('educational_institution')}}</p>
        }
      </div>
      }

      @if(is_ei_unique_link == true){
      <div class="form-group">
        <label>Select educational institution</label>
        <input type="text" [value]="wizardForm.get('educational_institution')?.value?.name" disabled>
      </div>
      }

      @if(isRecommendedInstitution && is_ei_unique_link == false) {
      <h2 class="wizard__heading">Enter details of the educational
        institution</h2>
      <div class="form-group">
        <label>Educational institution name</label>
        <input type="text" formControlName="educational_institution_name">
        @if(validateFormControl('educational_institution_name')){
        <p class="error">{{validationMessage('educational_institution_name')}}</p>
        }
      </div>
      }

      @if(isRecommendedInstitution){
      <div class="form-group">
        <label>Educational institution email </label>
        <input type="email" formControlName="educational_institution_contact_email">
        @if(validateFormControl('educational_institution_contact_email')){
        <p class="error">{{validationMessage('educational_institution_contact_email')}}</p>
        }
      </div>

      <div class="form-group">
        <label>Educational institution contact number</label>
        <input type="tel" maxlength="10" formControlName="educational_institution_contact_number"
          (keypress)="validateNumericInput($event)">
        @if(validateFormControl('educational_institution_contact_number')){
        <p class="error">{{validationMessage('educational_institution_contact_number')}}</p>
        }
      </div>
      <div class="form-group">
        <label>Educational institution website</label>
        <input type="text" formControlName="educational_institution_website">
        @if(validateFormControl('educational_institution_website')){
        <p class="error">{{validationMessage('educational_institution_website')}}</p>
        }
      </div>
      }

      <div class="form-group">
        <label for="studentNumber">
          Student number (optional)
        </label>
        <input id="studentNumber" type="text" formControlName="student_number" />
        @if(validateFormControl('student_number')){
        <p class="error">{{validationMessage('student_number')}}</p>
        }
      </div>

      <div class="form-group">
        <label for="courseFees">
          Course fees
        </label>
        <input currencyMask id="courseFees" class="text-input" formControlName="course_fees" autocomplete="off"
          (keypress)="validateNumericInput($event)" />
        @if(validateFormControl('course_fees')){
        <p class="error">{{validationMessage('course_fees')}}</p>
        }
      </div>


      <div class="form-group form-group--radio">
        <h2 class="wizard__heading">
          Who will make the payment while the student studies?
        </h2>

        <label class="radio-option">
          <input type="radio" value="student" formControlName="payment_made_by" />
          Student
        </label>

        <label class="radio-option">
          <input type="radio" value="sponsor" formControlName="payment_made_by" />
          Someone else (sponsor)
        </label>
        @if(validateFormControl('payment_made_by')){
        <p class="error">{{validationMessage('payment_made_by')}}</p>
        }
      </div>


      <div formGroupName="sponsor" class="sponsor_form" [class.hidden]="!showSponsorForm()">

        <h2 class="wizard__heading">Tell us about the sponsor</h2>

        <div class="form-group">
          <label for="sponsorName">Sponsor name</label>
          <input id="sponsorName" type="text" formControlName="sponsor_name" />
          @if(validateFormControl('sponsor.sponsor_name')){
          <p class="error">{{validationMessage('sponsor.sponsor_name')}}</p>
          }
        </div>

        <div class="form-group">
          <label for="sponsorSurname">Sponsor surname</label>
          <input id="sponsorSurname" type="text" formControlName="sponsor_surname" />
          @if(validateFormControl('sponsor.sponsor_surname')){
          <p class="error">{{validationMessage('sponsor.sponsor_surname')}}</p>
          }
        </div>

        <div class="form-group">
          <label for="sponsorIdNumber">Sponsor ID number</label>
          <input id="sponsorIdNumber" type="tel" maxlength="13" formControlName="sponsor_id_number"
            (keypress)="validateNumericInput($event)" />
          @if(validateFormControl('sponsor.sponsor_id_number')){
          <p class="error">{{validationMessage('sponsor.sponsor_id_number')}}</p>
          }
        </div>

        <div class="form-group">
          <label for="sponsorEmail">Sponsor email</label>
          <input id="sponsorEmail" type="email" formControlName="sponsor_email" />
          @if(validateFormControl('sponsor.sponsor_email')){
          <p class="error">{{validationMessage('sponsor.sponsor_email')}}</p>
          }
        </div>

        <div class="form-group">
          <label for="sponsorContactNumber">Sponsor contact number</label>
          <input id="sponsorContactNumber" type="tel" maxlength="10" formControlName="sponsor_contact_number"
            (keypress)="validateNumericInput($event)" />
          @if(validateFormControl('sponsor.sponsor_contact_number')){
          <p class="error">{{validationMessage('sponsor.sponsor_contact_number')}}</p>
          }
        </div>

        <div class="form-group">
          <h2 class="wizard__heading">The following section must be completed by the sponsor</h2>
          <p>
            <u (click)="openSponsorDialog()" style="cursor: pointer;">Click here</u> if the sponsor is not with you
            and
            you want to send them a link to continue with
            the application.
          </p>
        </div>

      </div>

      <!-- Terms -->
      <div class="form-group form-group--checkbox">
        <label>
          <input type="checkbox" formControlName="terms" />
          I agree to the <a href="/terms-and-conditions">terms and conditions</a>
        </label>
      </div>

      <div class="form-actions">

        <button type="submit" [disabled]="formsValid()" form="studentForm">
          Let's continue
        </button>
      </div>
    </form>

  </div>
</div>